<template>
  <span class="rs-tag" :class="{ 'rs-tag--long': long }" :data-shift="shift">
    <span aria-hidden="true">{{ long ? full : short }}</span>
    <span v-if="!long" class="rs-tag__sr">{{ full }}</span>
  </span>
</template>

<script>
/**
 * Oznaka smene ("Sm. 2" ili, sa `long`, "Smena 2") u boji te smene. Isti izgled na telefonu i na
 * računaru (boje su tokeni --rm-shift-N-*), pa se smena prepoznaje na prvi pogled u svakom izveštaju.
 * Čitač ekrana uvek čita punu reč, a ne skraćenicu.
 */
export default {
  name: "ReportShiftTag",
  props: {
    shift: { type: Number, required: true },
    long: { type: Boolean, default: false },
  },
  computed: {
    short() {
      return this.$t("report_mobile.shift_short", { n: this.shift });
    },
    full() {
      return this.$t("report_mobile.shift_n", { n: this.shift });
    },
  },
};
</script>

<style lang="scss">
.rs-tag {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: none;
  height: 20px;
  padding: 0 8px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  background: var(--rs-bg, var(--rm-chip-bg));
  color: var(--rs-fg, var(--rm-chip-text));

  @for $n from 1 through 4 {
    &[data-shift="#{$n}"] {
      --rs-bg: var(--rm-shift-#{$n}-bg);
      --rs-fg: var(--rm-shift-#{$n}-fg);
    }
  }

  &__sr {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0 0 0 0);
    white-space: nowrap;
  }
}
</style>
